@if (materials() === null) {
  <h2>Particles</h2>
  <app-loader />
} @else if (materials()?.length === 0) {
  <h2>Particles</h2>
  <p>No Materials found</p>
} @else if (selectedMaterial() === null) {
  <ng-container [ngTemplateOutlet]="materialSelect" />
  <p>Please select a meterial.</p>
} @else {
  <ng-container [ngTemplateOutlet]="materialSelect" />
  <p>Below is a list of all particles of {{selectedMaterial()?.name}}.</p>

  @if (particles().length) {
    <angular2-smart-table [settings]="settings" [source]="source" />
  } @else {
    <app-loader />
  }
}

<ng-template #materialSelect>
  <div class="header">
    <h2>Particles</h2>
    <select (change)="onMaterialChange($event)" id="Material">
      <option value="" [disabled]="!!selectedMaterial()" >-- Select a material --</option>
      @for (material of materials(); track material.id) {
        <option [selected]="selectedMaterial()?.id === material.id" [value]="material.id">
          {{ material.name }}
        </option>
      }
    </select>
  </div>
</ng-template>
